import { render, staticRenderFns } from "./ModalTotem.vue?vue&type=template&id=7c512f18&"
import script from "./ModalTotem.vue?vue&type=script&lang=js&"
export * from "./ModalTotem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports